/*
    Configurazione dell'applicazione diversificata per ambiente:
    dev: ambiente di sviluppo
    staging: ambiente di staging
    production: ambiente di produzione
 */

import {get} from './Storage';
var AppSettings = get();
var urlGetNews;
var localStorageName;
if(AppSettings.isauthenticated){
    urlGetNews = "/CommunicationService.svc/v1/news/popup/private/5/";
    localStorageName = "PrivateTopNews";
}
else{
    urlGetNews = "/CommunicationService.svc/v1/news/popup/public/5/";
    localStorageName = "PublicTopNews";
}

var cacheMinutes = parseInt(AppSettings.cacheduration);
if(cacheMinutes <= 0 || isNaN(cacheMinutes)){
    if (typeof(Storage) !== "undefined") {
        sessionStorage.removeItem(localStorageName);
    }
    cacheMinutes = 0;
}

export default {
    development: {
        name: "dev",
        cookieName:"topNewsRead",
        sessionName:"topNewsRead",
        urlGetNews : "/json/topnews.json",
        urlSetReadByuser: "/json/setreadbyuser.json",
        localStorageName: {name: localStorageName, lifeTime: (1 * cacheMinutes * 60 * 1000)},
        
    },

    staging: {
        name: "staging",
        cookieName:"topNewsRead",
        sessionName:"topNewsRead",
        urlGetNews : urlGetNews,
        urlSetReadByuser: "/CommunicationService.svc/v1/article/[NEWS_ID]",
        localStorageName: {name: localStorageName, lifeTime: (1 * cacheMinutes * 60 * 1000)},
    },

    production: {
        name: "production",
        cookieName:"topNewsRead",
        sessionName:"topNewsRead",
        urlGetNews : urlGetNews,
        urlSetReadByuser: "/CommunicationService.svc/v1/article/[NEWS_ID]",
        localStorageName: {name: localStorageName, lifeTime: (1 * cacheMinutes * 60 * 1000)},
    }
};